/** Генерит полный урл для отображения аватарок. */
import { useMemo } from 'react'
import { getApiImageUrl } from '../helpers/string'

export const useAvatar = (avatarPath?: string | null): string => {
  return useMemo(() => getApiImageUrl(avatarPath), [avatarPath])
}
